import React from 'react'
import { Fragment } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { P } from '../../AbstractElements'
import { Link } from 'react-router-dom'
import { MapPin, Mail, Phone } from 'react-feather'
import { PrimeCollegePrepLogo } from '../../Constant'

const Footer = () => {
	return (
		<Fragment>
			<footer className="footer">
				<div className="footer-top">
					<Container fluid={true}>
						<Row>
							<Col md="8">
								<div className="footer-widget footer-about">
									<div className="footer-logo">
										<img src={PrimeCollegePrepLogo} alt="Prime College Prep" />
									</div>
								</div>
							</Col>
							<Col md="4">
								<div className="footer-widget footer-contact">
									<div className="footer-contact-info">
										<div className="footer-address">
											<MapPin className="footer-icon" />
											<P>Cherry Hill, NJ 08003</P>
										</div>
										<div className="footer-address">
											<Mail className="footer-icon" />
											<P>info@primecollegeprep.com</P>
										</div>
										<div className="footer-address">
											<Phone className="footer-icon" />
											<P>+1 609-297-6939</P>
										</div>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
				<div className="footer-bottom">
					<Container fluid={true}>
						<Row>
							<Col md="8">
								<div className="privacy-policy">
									<ul>
										<li>
											<Link to="#">Terms</Link>
										</li>
										<li>
											<Link to="#">Privacy</Link>
										</li>
									</ul>
								</div>
							</Col>
							<Col md="4" className="text-right">
								<div className="copyright-text">
									<P>© 2024 Prime College Prep. All rights reserved.</P>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			</footer>
		</Fragment>
	)
}

export default Footer
